export default {
  'Resize for': 'Größe ändern',
  'Add 10 videos at most': 'Fügen maximal 10 Videos hinzu.',
}